import script from "./settingsActiveDirectory.vue?vue&type=script&setup=true&lang=ts"
export * from "./settingsActiveDirectory.vue?vue&type=script&setup=true&lang=ts"

import "./settingsActiveDirectory.vue?vue&type=style&index=0&id=535047fe&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535047fe"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
